import React from 'react';
import classnames from 'classnames';

const itemsCount = 12;

type Props = {
  className?: string;
};

const widgetSpinner = ({ className }: Props) => (
  <div className={classnames('sk-circle', className)}>
    {Array(itemsCount)
      .fill(0)
      .map((_el, index) => (
        <div className={`sk-circle${index + 1} sk-child`} key={index} />
      ))}
  </div>
);

export default widgetSpinner;
